import { Checkbox, checkboxStates } from "@visiblethread/react-components";
import { arrayOf, bool, func, shape, string } from "prop-types";

const SelectAllCheckbox = ({
  isAllFilesApplied,
  files,
  loading,
  isAllFilesChecked,
  handleSelectAllFiles,
}) => {
  if (!isAllFilesApplied && files.length > 0 && !loading) {
    return (
      <div className="select_all_checkbox" data-testid="select-all-checkbox">
        <Checkbox
          state={
            isAllFilesChecked ? checkboxStates.checked : checkboxStates.empty
          }
          handleChange={handleSelectAllFiles}
          aria-label="Select all files"
        />
      </div>
    );
  }
  return null;
};

SelectAllCheckbox.propTypes = {
  isAllFilesApplied: bool.isRequired,
  files: arrayOf(
    shape({
      name: string.isRequired,
    })
  ).isRequired,
  loading: bool.isRequired,
  isAllFilesChecked: bool.isRequired,
  handleSelectAllFiles: func.isRequired,
};

export default SelectAllCheckbox;
